module.exports = {"title":"Outlet","outlet_details":"Outlet Details","create_outlet":"Create New Outlet","pricebook":"Pricebook","central_devices":"Central Devices","outlet_count":"{1} :value outlet|[2,*] :value outlets","delete_success":"Outlet has been successfully deleted","delete_text":"This will also delete device associated with this outlet. Continue ?"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en/outlet.php
// module id = 2enI
// module chunks = 99